import { render, staticRenderFns } from "./Plano.vue?vue&type=template&id=1dc19840&scoped=true&"
import script from "./Plano.vue?vue&type=script&lang=js&"
export * from "./Plano.vue?vue&type=script&lang=js&"
import style0 from "./Plano.vue?vue&type=style&index=0&id=1dc19840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc19840",
  null
  
)

export default component.exports